import { paginatedMemberAuditSchema } from "../schemas/member-audit";
import { fetchApi } from "./internal";

export type MemberAuditListParams = {
	limit?: number;
	offset?: number;
};

export const memberAudit = {
	list: (clubId: string, memberId: string, params: MemberAuditListParams = {}) => {
		const query = new URLSearchParams();
		if (params.limit !== undefined) query.set("limit", String(params.limit));
		if (params.offset !== undefined) query.set("offset", String(params.offset));
		const qs = query.toString();
		const suffix = qs ? `?${qs}` : "";
		return fetchApi(
			`/clubs/${clubId}/members/${memberId}/audit${suffix}`,
			paginatedMemberAuditSchema,
		);
	},
};
